module.exports = __webpack_public_path__ + "media/GrottaHouse_Web.14641143.mp4";